import { useIsTestEnvironment } from 'hooks';
import { useQuery } from '@tanstack/react-query';
import coSellClient from 'packages/cosell/api/coSellClient';

export const useTestConnection = (shouldFetch = false) => {
  const isTestEnvironment = useIsTestEnvironment();

  // for demo and test environments, we want to always return a connected stateP
  const defaultQueryObject = {
    data: { connected: true },
    isLoading: false,
    isError: false,
    error: null,
    isFetching: false,
    refetch: () => Promise.resolve(),
  };

  const testConnectionQuery = useQuery({
    queryKey: ['co-sell-aws-test-connection'],
    queryFn: async () => {
      return coSellClient.getTestConnection();
    },
    enabled: shouldFetch && !isTestEnvironment,
  });

  const isV3Connected =
    isTestEnvironment || testConnectionQuery?.data?.connected;

  return {
    testConnectionQuery: isTestEnvironment
      ? defaultQueryObject
      : testConnectionQuery,
    isV3Connected,
  };
};
